/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_f1_budget_subtitle = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Build your optimal team within budget`)
};

const es_f1_budget_subtitle = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Construye tu equipo óptimo dentro del presupuesto`)
};

const de_f1_budget_subtitle = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stelle dein optimales Team innerhalb des Budgets zusammen`)
};

const nl_f1_budget_subtitle = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stel je optimale team samen binnen het budget`)
};

const fr_f1_budget_subtitle = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Construisez votre équipe optimale dans le budget`)
};

const it_f1_budget_subtitle = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Costruisci il tuo team ottimale nel budget`)
};

const pt_br2_f1_budget_subtitle = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monte sua equipe ideal dentro do orçamento`)
};

const pt_f1_budget_subtitle = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Construa a sua equipa ideal dentro do orçamento`)
};

const ja_f1_budget_subtitle = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`予算内で最適なチームを編成`)
};

const zh_f1_budget_subtitle = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在预算内组建最优车队`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const f1_budget_subtitle = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.f1_budget_subtitle(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("f1_budget_subtitle", locale)
	if (locale === "en") return en_f1_budget_subtitle(inputs)
	if (locale === "es") return es_f1_budget_subtitle(inputs)
	if (locale === "de") return de_f1_budget_subtitle(inputs)
	if (locale === "nl") return nl_f1_budget_subtitle(inputs)
	if (locale === "fr") return fr_f1_budget_subtitle(inputs)
	if (locale === "it") return it_f1_budget_subtitle(inputs)
	if (locale === "pt-BR") return pt_br2_f1_budget_subtitle(inputs)
	if (locale === "pt") return pt_f1_budget_subtitle(inputs)
	if (locale === "ja") return ja_f1_budget_subtitle(inputs)
	return zh_f1_budget_subtitle(inputs)
};